import http from "../utils/httpyb";

/**
 *  索票索证二级列表
 */
export function getTicketList(params) {
  return http({
    method: 'get',
    url: '/govapi/saasdetec/card/list',
    params
  });
}

/**
 *  索票索证二级列表导出
 */
export function exportData(params) {
  return http({
    method: 'get',
    url: '/govapi/saasdetec/card/export',
    params
  });
}